import request from "@/utils/request";

// 登录
export function login(data: any) {
  return request({
    url: "/login",
    method: "post",
    params: data,
  });
}

export function enroll(data: any, params: any) {
  return request({
    url: "/enroll",
    method: "post",
    data: data,
    params: params,
  });
}

export function verifyCode(data: any) {
  return request({
    url: "/verifyCode",
    method: "post",
    params: data,
  });
}

export function forgetPassword(data: any) {
  return request({
    url: "/forgetPassword",
    method: "post",
    params: data,
  });
}

// 获取用户信息
export function getInfo(token: string) {
  return request({
    url: "/vue-admin-template/user/info",
    method: "get",
    params: { token },
  });
}

// 更新用户信息
export function UpdateInfo(data: any) {
  return request({
    url: "/webUser",
    method: "put",
    data: data,
  });
}
export function webUserStatus(data: any) {
  return request({
    url: "/webUserStatus",
    method: "put",
    params: data,
  });
}

export function getFeedBackList(data: any) {
  return request({
    url: "/feedbackList",
    method: "get",
    params: data,
  });
}

export function getAdList(data: any) {
  return request({
    url: "/adverts",
    method: "get",
    params: data,
  });
}

export function editAdvertise(data: any) {
  return request({
    url: "/advert",
    method: "put",
    data: data,
  });
}

export function addAdvertise(data: any) {
  return request({
    url: "/advert",
    method: "post",
    data: data,
  });
}

export function deleteAd(params: any) {
  return request({
    url: "/advert",
    method: "delete",
    params: params,
  });
}

export function addNotice(data: any) {
  return request({
    url: "/notice",
    method: "post",
    data: data,
  });
}

export function deleteTicket(params: any) {
  return request({
    url: "/voucher",
    method: "delete",
    params: params,
  });
}

export function excel(params: any) {
  return request({
    url: "/excel",
    method: "get",
    params: params,
  });
}

export function searchGame(data: any) {
  return request({
    url: "/searchGame",
    method: "get",
    params: data,
  });
}

export function addTickets(data: any, data2: any) {
  return request({
    url: "/voucher",
    method: "post",
    params: data,
    data: data2,
  });
}

export function getTickets(data: any) {
  return request({
    url: "/vouchers",
    method: "get",
    params: data,
  });
}

export function getNotices(data: any) {
  return request({
    url: "/noticeList",
    method: "get",
    params: data,
  });
}

export function replyFeedback(data: any) {
  return request({
    url: "/feedback",
    method: "put",
    params: data,
  });
}

// 获取用户列表
export function userList(data: any) {
  return request({
    url: "/webUserList",
    method: "get",
    params: data,
  });
}

// 注销
export function logout() {
  return request({
    url: "/vue-admin-template/user/logout",
    method: "post",
  });
}
